export default {
    PRODUCT_CLICK: 'PRODUCT_CLICK'
}
